import React from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import {
  Box,
  ButtonStyled,
  SpanStyled,
  TextStyled,
} from "../../../styled/Elements";
import { useTranslation } from "react-i18next";

const VisibilityModal = ({ show, onHide, title, onVisibility }) => {
    const {t} = useTranslation()
  return (
    <Modal show={show} onHide={onHide} centered>
      <DeleteModalWrapper>
        <Box className="p-4">
          <Box className="mb-4">
            <Box>
              <SpanStyled size="20px" weight={800} color="var(--themeColor)">
                {`${t("change_visibility")}`}
              </SpanStyled>
              <TextStyled size="16px" color="var(--text2)">
                {t(`change_visibility_confirmation`)}
              </TextStyled>
            </Box>
          </Box>
          <Box className="d-flex justify-content-end">
            <Box className="mt-4 d-flex gap-3">
              <ButtonStyled
                label={t("Cancel")}
                bg={"var(--bgSecondary)"}
                color={"var(--text2)"}
                onClick={onHide}
              />
              <ButtonStyled label={t("yes_change")} bg="var(--themeColor)" onClick={onVisibility} />
            </Box>
          </Box>
        </Box>
      </DeleteModalWrapper>
    </Modal>
  );
};

export default VisibilityModal;

const DeleteModalWrapper = styled.div``;
